/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ExamSessionResponse } from './examSessionResponse';

export type GenericApiResponseExamSessionResponseData = ExamSessionResponse | null;
